import React from 'react';
import SmallHeaderImage from './SmallHeaderImage';

export const smallHeaderImageHandler = {
    tags,
    elementEditor,
    defaultStyle,
    component,
    families
}

function component(element) {
    return <SmallHeaderImage element={element} />
}

function tags() {
    return {
        startTag: '<!-- Email Header : BEGIN -->',
        endTag: '<!-- Email Header : END -->'
    }
}

function families() {
    return [
        'image'
    ]
}

function defaultStyle() {
    return {
        wrapper: {
            padding: '20px 0px',
            textAlign: 'center'
        },
        elementProps: {
            source: 'https://via.placeholder.com/200x200',
            width: '200',
            height: 200,
            altText: 'alt_text',
            border: '0'
        },
        styleProps: {
            width: '100%',
            maxWidth: '200px',
            height: '200px',
            background: '#dddddd',
            fontFamily: 'sans-serif',
            fontSize: '15px',
            lineHeight: '15px',
            color: '#555555',
            display: 'block',
            margin: 'auto'
        },
        className: 'g-img'
    }
}
/* function elementEditor(elementStyle, templateStyle = null, defaultStyle = true) {
    //Take what is relevant from the template
    return (
        `<tr>
            <td style="padding: ${elementStyle.wrapper.padding}; text-align: ${elementStyle.wrapper.textAlign}">
                <img 
                    src="${elementStyle.elementProps.source}" 
                    width="${elementStyle.elementProps.width}" 
                    height="${elementStyle.elementProps.height}" 
                    alt="${elementStyle.elementProps.altText}"
                    border="${elementStyle.elementProps.border}"
                    style="width: ${elementStyle.styleProps.width};
                    height: ${elementStyle.styleProps.height}; 
                    max-width: ${elementStyle.styleProps.maxWidth}; 
                    background: ${elementStyle.styleProps.background}; 
                    font-family: ${elementStyle.styleProps.fontFamily}; 
                    font-size: ${elementStyle.styleProps.fontSize}; 
                    line-height: ${elementStyle.styleProps.lineHeight}; 
                    color: ${elementStyle.styleProps.color}; 
                    display: ${elementStyle.styleProps.display};
                    margin: ${elementStyle.styleProps.margin};" 
                    class=${elementStyle.className}
                >
            </td>
        </tr>`
    )
}; */

function elementEditor(elementStyle, templateStyle = null, defaultStyle = true) {
    //Take what is relevant from the template
    return (
        `<tr>
        <td style="padding: 20px 0; text-align: center">
            <img         src="${elementStyle.elementProps.source}"  height="${parseInt(elementStyle.styleProps.height)}" alt="alt_text" border="0" style="height: auto; max-height: 200px; max-width: 100%; background: #dddddd; font-family: sans-serif; font-size: 15px; line-height: 15px; color: #555555;">
        </td>
    </tr>`
    )
};
